import React from 'react';
import { Button, Typography } from '@mui/material';
import { SharedContainer } from '../components/shared-container/container';
import { SharedCard } from '../components/shared-card/card';

const Home = () => {
  return (
    <SharedContainer>
      <SharedCard
        sx={{
          width: 'auto',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
          <Typography variant="h3" textAlign={'center'} gutterBottom>
            Optimo Capital
          </Typography>
          <Typography variant="body1" paragraph>
            Login/Register here
          </Typography>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            href="/sign-in"
            style={{ marginBottom: '10px' }}
          >
            Connector / RM / Reseller login
          </Button>

          <Button
            variant="contained"
            color="secondary"
            fullWidth
            href="/partner-sign-in"
          >
            Partner login
          </Button>
      </SharedCard>
    </SharedContainer>
  );
};

export default Home;
